import { render, staticRenderFns } from "./configName.vue?vue&type=template&id=268fbc0f&scoped=true&"
import script from "./configName.vue?vue&type=script&lang=js&"
export * from "./configName.vue?vue&type=script&lang=js&"
import style0 from "./configName.vue?vue&type=style&index=0&id=268fbc0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268fbc0f",
  null
  
)

export default component.exports